<template>
      <v-data-table
      :headers="headers"
      :items="listSecteurDactivité"
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-toolbar-title>Les Secteurs d'activité</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-dialog
            v-model="dialog"
            max-width="500px"
          >
                <template v-slot:activator="{ on , attr }">
                <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    v-bind="attr"
                    v-on="on"
                    @click="save"
                >
                    Nouveau Secteur d'activité
                </v-btn>
                </template>
                <v-card>
                <v-card-title>
                    <span class="text-h5">{{ formTitle }}</span>
                </v-card-title>
    
                <v-card-text>
                    <v-container>
                    <v-row>
                       
                        <v-text-field
                            v-model="libelle"
                            label="Libelle secteur d'activité"
                            outlined
                            :error-messages="errorMessage.libelle"
                        ></v-text-field>
                    </v-row>
                    </v-container>
                </v-card-text>
    
                <v-card-actions>
                    <v-spacer></v-spacer>
                      <div class="annuler">
                        <v-btn
                        color="#FFCDD2"
                        variant="text"
                        @click="close"
                        >
                        Annuler
                        </v-btn>
                    </div>
  
                        <v-btn
                        color="primary" 
                        variant="text"
                        @click="ajoueModifieSecteurDactivite"
                        >
                          Enregistrer
                        </v-btn>
                
                </v-card-actions>
                </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Ce secteur d'activité sera supprimé</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <div style="display:flex;justify-content:space-around;width:100%">
                     <div class="primary" style="display:flex"> <v-btn  class="primary" @click="closeDelete">Annuler</v-btn></div>
                    <div class="annuler" style="display:flex;"><v-btn   color="#FFCDD2"
                        variant="text" @click="deleteItemConfirm">Supprimer</v-btn></div>
              </div>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          size="small"
          class="me-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          size="small"
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        la liste des secteur d'activités est vide
      </template>
    </v-data-table>
</template>

<script>
  export default {
    data: () => ({
      listSecteurDactivité: [],
      formTitle : String,
      editedItem: Object.assign({}), 
      libelle: '',
      ajouter: false,
      modifier: false,
      id: '',
      dialog: false,
      dialogDelete: false,
      errorMessage: String,
      headers: [
        {
          text: 'libelle',
          align: 'start',
          sortable: false,
          value: 'libelle',
        },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    }),

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.secteurDactiviteListe()
    },

      methods: {
        secteurDactiviteListe(){
          this.loading = true
          this.$http.get(`auth/secteurActivite`).then(({ data }) => {
          this.listSecteurDactivité = data.data;
          
        })
      },
      addSecteurDactivite(){
        let data = {
            libelle : this.libelle
        };
          this.$http.post(`auth/secteurActiviteRegister`,data).then(response => {
          this.listSecteurDactivité.unshift(response.data.data);
          this.close ()
          data = '';
          this.$toast.success({
          title: "Nouveau Secteur D'activité",
          message: "Secteur d'activité ajouter avec succes",
          });
        }).catch((error) => {
            this.errorMessage = error.response.data.errors
            console.log(this.errorMessage);
        })
      },
      updateSecteurDactivite(id){
        let data = {
            libelle : this.libelle
        };
        try {
          this.$http.put(`auth/updateSecteurDactivite/${id}`,data).then(response => {
          const index= this.listSecteurDactivité.findIndex((dp) => dp.id == this.editedItem.id)
          this.listSecteurDactivité.splice(index,1,response.data.data)
            this.close ()
            this.$toast.success({
            title: "Modification secteur D'activité",
            message: "Secteur d'activité Modifier avec succes",
            });
            this.libelle = '';
          })
        } catch  {
          this.$toast.error({
            title: "Modification secteur D'activité",
            message: "Impossible de de modifier ce secteur d'activité"
          })
        }
      },


      deleteSecteurDactivite(id) {
        this.$http.delete(`auth/destroySecteurDactivite/${id}`)
          .then(response => {
            const index= this.listSecteurDactivité.findIndex((dp) => dp.id == id)
            this.listSecteurDactivité.splice(index,1)
            if(response.status === 200){
              this.$toast.success({
              title: "Suppression  secteur d'activité",
            message: "Secteur d'activité supprimer avec succes",
            });
          }
          
          }).catch((error) => {

              this.$toast.error({
                title: "Suppression secteur d'activité",
                message: error.response.data.message
              }) 
            })
      },
     

      deleteItem (item) {
        this.editedItem = item;
        this.dialogDelete = true
      },

      //Appel de la function qui confirme la suppression
      deleteItemConfirm () {
        this.deleteSecteurDactivite(this.editedItem.id);
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.ajouter = false
        this.libelle = '';
        this.errorMessage = "";
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
//Permet de lancer le formulair d'ajoue 
      save () {
        this.ajouter = true
        this.errorMessage = "";
        this.formTitle = "Ajoue secteur d'activité"
      },
//Permer de charger l'id lor de la modification d'un secteur d'activité
      editItem (item) {
        this.libelle = item.libelle;
        this.errorMessage = "";
        this.dialog=true;
        this.editedItem = item;
        this.formTitle = "Modification Secteur d'activité"
      },
//Ajoue et modification d'un secteur d'activité
      ajoueModifieSecteurDactivite () {
       
        if(!this.editedItem.id) {
            this.addSecteurDactivite()
        }else {
            this.updateSecteurDactivite(this.editedItem.id)
        }
      },
    },
  }
</script>

<style scoped>
  .annuler  {
        margin-right: 10px;
}
.annuler :hover {
        background-color: red !important;
        color: aliceblue;
}
</style>